import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { State, toDataSourceRequestString } from '@progress/kendo-data-query';
import { fadeInOnEnterAnimation } from 'angular-animations';
import { NotifyService } from 'src/app/_services/notify.service';
import { forkJoin } from 'rxjs';
import { Asset } from 'src/app/_models/asset';
import { AssetFilter } from 'src/app/_models/assetFilter';
import { ComponentType } from 'src/app/_models/componentType';
import { Dimension } from 'src/app/_models/dimension';
import { AssetService } from 'src/app/assetManagement/_services/asset.service';
import { DimensionService } from 'src/app/setup/_services/dimension.service';
import { ComponentTypeService } from 'src/app/setupClass/_services/componentType.service';

@Component({
   selector: 'app-asset-search',
   templateUrl: './asset-search.component.html',
   styleUrls: ['./asset-search.component.scss'],
   animations: [fadeInOnEnterAnimation()],
})
export class AssetSearchComponent implements OnInit {
   public state: State = {
      filter: {
         logic: 'and',
         filters: [],
      },
   };
   @Input() opened = false;
   @Input() assetIndex: number;
   @Input() availableForBooking: Date;
   @Input() bookingModule = false;
   @Output() assetSelect: EventEmitter<[number, number, string]> = new EventEmitter<[number, number, string]>();
   loading = false;
   loadingComponentType = false;
   constructor(private componentTypeService: ComponentTypeService, private dimensionService: DimensionService, private notify: NotifyService, private assetService: AssetService) {}
   assetFilter: AssetFilter;
   componentTypes: ComponentType[];
   public dataComponentTypes: Array<ComponentType>;
   dimensions: Dimension[];
   public gridData: any[];

   ngOnInit() {
      this.resetFilter();
      forkJoin([this.componentTypeService.getComponentTypesFull(), this.dimensionService.getDimensionsForGrouping()]).subscribe(([_componentTypes, _dimensions]) => {
         this.componentTypes = _componentTypes;
         this.dataComponentTypes = this.componentTypes.slice();

         this.dimensions = _dimensions;
         this.resetFilter();
      });
   }
   filterAssets() {
      this.state = {
         filter: {
            logic: 'and',
            filters: [],
         },
      };

      this.loading = true;

      this.state.filter.filters.push({
         field: 'ComponentTypeId',
         value: this.assetFilter.componentTypeId,
         operator: 'contains',
      });
      this.state.filter.filters.push({
         field: 'Make',
         value: this.assetFilter.make,
         operator: 'contains',
      });
      this.state.filter.filters.push({
         field: 'Model',
         value: this.assetFilter.model,
         operator: 'contains',
      });
      this.state.filter.filters.push({
         field: 'Description',
         value: this.assetFilter.description,
         operator: 'contains',
      });
      this.state.filter.filters.push({
         field: 'Barcode',
         value: this.assetFilter.assetBarCode,
         operator: 'contains',
      });
      this.state.filter.filters.push({
         field: 'FunctionalLocation1',
         value: this.assetFilter.functionalLocation1,
         operator: 'contains',
      });
      this.state.filter.filters.push({
         field: 'FunctionalLocation2',
         value: this.assetFilter.functionalLocation2,
         operator: 'contains',
      });
      this.state.filter.filters.push({
         field: 'FunctionalLocation3',
         value: this.assetFilter.functionalLocation3,
         operator: 'contains',
      });
      this.state.filter.filters.push({
         field: 'AvailableForBooking',
         value: this.availableForBooking,
         operator: 'gte',
      });

      let counter = 1;
      this.assetFilter.dimensionDataIdList.forEach((dimensionDataId) => {
         this.state.filter.filters.push({
            field: 'DataId' + counter.toString(),
            value: this.assetFilter.dimensionDataIdList[counter - 1],
            operator: 'contains',
         });
         counter++;
      });
      const queryStr = `${toDataSourceRequestString(this.state)}`; // Serialize the state
      this.assetService.getAssetFilter(queryStr).subscribe(
         (data) => {
            this.gridData = data;
            this.loading = false;
         },
         (error) => {
            const message = error;
            this.notify.error(message);
            this.loading = false;
         }
      );
   }
   resetFilter() {
      this.assetFilter = {
         assetBarCode: null,
         model: null,
         make: null,
         description: null,
         componentTypeId: null,
         functionalLocation1: null,
         functionalLocation2: null,
         functionalLocation3: null,
         dimensionDataIdList: [],
         availableForBooking: this.availableForBooking,
         bookingModule: this.bookingModule,
      };
      if (this.dimensions) {
         this.dimensions.forEach((dim) => {
            this.assetFilter.dimensionDataIdList.push(null);
         });
      }

      this.gridData = [];
   }
   selectAsset(asset: Asset) {
      this.assetSelect.emit([asset.assetCode, this.assetIndex, `${asset.description} (${asset.assetBarcode})`]);
      this.resetFilter();
   }
   close() {
      this.assetSelect.emit([null, this.assetIndex, '']);
   }
   handleFilterComponentType(value) {
      this.dataComponentTypes = this.componentTypes.filter(
         (a) => a.typeCode.toLowerCase().indexOf(value.toLowerCase()) !== -1 || a.description.toLowerCase().indexOf(value.toLowerCase()) !== -1
      );
   }
   public rowCallback(context: RowClassArgs) {
      const isEven = context.index % 2 === 0;
      return {
         even: isEven,
         odd: !isEven,
      };
   }
}
